import { render } from "./App.vue?vue&type=template&id=3f31cf8a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3f31cf8a&lang=css"

import exportComponent from "/Users/haoche/Documents/Parsons/2024 Spring/Major Studio 2/thesis/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__